import React from 'react';

// useState-compatible hook that mirrors its value into localStorage under
// `key`. Initial value is read from storage on first mount; changes are
// written synchronously on every update. Assumes `key` is stable across the
// lifetime of the component (we don't re-read when key changes).
export default function useLocalStorageState(key, defaultValue) {
  const [value, setValue] = React.useState(() => {
    try {
      const raw = window.localStorage.getItem(key);
      if (raw != null) return JSON.parse(raw);
    } catch {
      // fall through to default
    }
    return defaultValue;
  });

  React.useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // Storage full / unavailable — silently drop. The in-memory state
      // still works; persistence just fails this round.
    }
  }, [key, value]);

  return [value, setValue];
}
